<template>
  <div :class="activeBreakpoint">
    <template v-if="organization_unit_store.getRoot">
      <CompositeNavbar />
      <RouterView />
      <CompositeReporting />
      <CommonFooter />
    </template>
    <LayoutContainer class="error" v-else-if="false">
      <TrafficCone color="var(--vc-orange)" />
      <p class="pipeline-state" style="color: var(--vc-orange)"></p>
    </LayoutContainer>
    <LayoutContainer style="margin-top: 250px" v-else>
      <CommonLoader />
      <p class="pipeline-state">Chargement de l'application..<br /></p>
    </LayoutContainer>
  </div>
</template>

<script setup lang="ts">
import CompositeNavbar from '@/components/composite/CompositeNavbar.vue'
import LayoutContainer from '@/components/layout/LayoutContainer.vue'
import CommonLoader from '@/components/common/CommonLoader.vue'
import CompositeReporting from '@/components/composite/CompositeReporting.vue'
import CommonFooter from '@/components/common/CommonFooter.vue'
import { parse_jwt } from '@/service/service_security'
import { onMounted, ref } from 'vue'
import { useBreakpoints } from '@vueuse/core'
import { application_breakpoints } from '@/service/service_breakpoints'
import { TrafficCone } from 'lucide-vue-next'
import { useOrganizationUnitStore } from '@/stores/store_organization_unit'
import { useSecurityStore } from '@/stores/store_security'
import { useUnitStore } from '@/stores/store_unit'
import { toast } from 'vue-sonner'

const breakpoints = useBreakpoints(application_breakpoints)
const activeBreakpoint = breakpoints.active()

const security_store = useSecurityStore()
const organization_unit_store = useOrganizationUnitStore()
const unit_store = useUnitStore()

function handleConnection() {
  security_store.fetchUser()
  const jwt = security_store.getJWT
  if (!jwt) {
    return
  }

  const payload = parse_jwt(jwt)
  const expiration_date = new Date(payload.exp * 1000)
  const current_date = new Date()
  const session_duration = expiration_date.getTime() - current_date.getTime()

  console.debug(`logout in ${session_duration}`)
  setTimeout(() => {
    alert('Votre session à exipiré.')
    security_store.logout()
  }, session_duration)
}

onMounted(() => {
  handleConnection()
  const organization_unit_fetch = organization_unit_store.fetch()
  const unit_fetch = unit_store.fetch()
  Promise.all([organization_unit_fetch, unit_fetch]).then(() => {
    toast.success(`Bienvenue, ${security_store.user?.firstname}`)
  })
})
</script>

<style scoped>
.pipeline-state {
  text-align: center;
  color: var(--vc-primary);
  opacity: 0.6;
}

.error {
  margin-top: 400px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
